import { ref, watch, computed } from '@vue/composition-api'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'
import i18n from '@/libs/i18n'

export default function tableConfig(moduleName, arg = {}) {
  // Use toast
  const toast = useToast()

  const table = ref(null)
  const perPage = ref(arg.perPage ?? 10)
  const total = ref(arg.total ?? 0)
  const currentPage = ref(arg.currentPage ?? 1)
  const perPageOptions = arg.perPageOptions ?? [5, 10, 25, 50, 100]
  const searchQuery = ref(arg.searchQuery ?? '')
  const sortBy = ref(arg.sortBy ?? 'id')
  const isSortDirDesc = ref(arg.isSortDirDesc ?? true)
  const isBusy = ref(arg.isBusy ?? false)
  const extraParams = ref(arg.data ?? {})
  const endpoint = arg.endpoint ?? `${moduleName}/list`
  const dataMeta = computed(() => {
    const localItemsCount = table.value ? table.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: total.value,
    }
  })

  const refetchData = () => {
    table.value.refresh()
  }

  watch([currentPage, perPage], () => {
    refetchData()
  })
  watch([searchQuery], () => {
    currentPage.value = 1
    refetchData()
  })

  const list = (ctx, callback) => {
    isBusy.value = true
    store
      .dispatch(endpoint, {
        search: searchQuery.value,
        ordering: (isSortDirDesc.value ? '-' : '') + sortBy.value,
        limit: perPage.value,
        offset: (currentPage.value - 1) * perPage.value,
        ...extraParams.value,
      })
      .then(response => {
        callback(response.data.results)
        total.value = response.data.count
      })
      .catch(err => {
        console.log(err)
        toast({
          component: ToastificationContent,
          props: {
            title: i18n.t('Error fetching {module} list', { module: moduleName }),
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      }).finally(() => {
        isBusy.value = false
      })
  }

  return {
    list,
    perPage,
    currentPage,
    total,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    [`${moduleName}Table`]: table,
    isBusy,
    refetchData,
    extraParams,
  }
}
